import React, { Component } from 'react';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import emailjs from '@emailjs/browser';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Modal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isPrivacyPolicyOpen: false,
      privacyPolicyText: '  ',
      formData: {
        firstName: '',
        lastName: '',
        phone: '',
        checkIn: '',
        checkOut: '',
        guests: '',
        comment: ''
      }
    };

    this.openPrivacyPolicy = this.openPrivacyPolicy.bind(this);
    this.closePrivacyPolicy = this.closePrivacyPolicy.bind(this);
  }

  componentDidMount() {
    fetch('./privacyPolicy.txt') // Путь относительно Modal.js
      .then((response) => response.text())
      .then((data) => {
        // Преобразуем переносы строк в абзацы
        const paragraphs = data.split('\n').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ));
        this.setState({ privacyPolicyText: paragraphs });
      })
      .catch((error) => {
        console.error('Error fetching privacy policy:', error);
        this.setState({ privacyPolicyText: 'Failed to load privacy policy.' });
      });
  }


  openPrivacyPolicy() {
    this.setState({ isPrivacyPolicyOpen: true });
  }

  closePrivacyPolicy() {
    this.setState({ isPrivacyPolicyOpen: false });
  }


  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  
  handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const result = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: this.state.formData.firstName + ' ' + this.state.formData.lastName,
          phone: this.state.formData.phone,
          check_in: this.state.formData.checkIn,
          check_out: this.state.formData.checkOut,
          guests: this.state.formData.guests,
          message: this.state.formData.comment,
        },
        process.env.REACT_APP_EMAILJS_USER_ID
      );

      if (result.status === 200) {
        toast.success('🎉 Форма успешно отправлена!', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.onClose();
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('❌ Произошла ошибка при отправке формы', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  render() {
    const { isOpen, onClose } = this.props;

    if (!isOpen) return null;

    return (
       
        <div className="modal-overlay">
          <div className="modal-content">
          {!this.state.isPrivacyPolicyOpen && (
       <button className="close-button" onClick={onClose}>×</button>
     )}
            <h2>Забронировать номер</h2>
            <h4>Наша администрация ответит вам в течение 24 часов</h4>
            <form onSubmit={this.handleSubmit} className="form_to_share" id='form_to_share'>
                <div className="form-group">
                  <label>Имя:</label>
                  <input 
                    type="text" 
                    name="firstName"
                    value={this.state.formData.firstName}
                    onChange={this.handleInputChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Фамилия:</label>
                  <input 
                    type="text" 
                    name="lastName"
                    value={this.state.formData.lastName}
                    onChange={this.handleInputChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Телефон:</label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={this.state.formData.phone}
                    onChange={this.handleInputChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Дата заезда:</label>
                  <input 
                    type="date" 
                    name="checkIn"
                    value={this.state.formData.checkIn}
                    onChange={this.handleInputChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Дата отъезда:</label>
                  <input 
                    type="date" 
                    name="checkOut"
                    value={this.state.formData.checkOut}
                    onChange={this.handleInputChange}
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Число гостей:</label>
                  <input 
                    type="number" 
                    name="guests"
                    value={this.state.formData.guests}
                    onChange={this.handleInputChange}
                    min="1" 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label>Комментарий:</label>
                  <textarea 
                    name="comment"
                    value={this.state.formData.comment}
                    onChange={this.handleInputChange}
                    rows="4"
                  />
                </div>
              <div className="form-group_privacy-agreement">
                <label>
                  <input type="checkbox" required className="privacy-checkbox"/>
                  Я согласен(а) с <a
                            href="javascript:void(0)" // Заглушка, чтобы ссылка работала
                            className="privacy-policy-link"
                            onClick={(e) => {
                                e.preventDefault(); // Предотвращаем переход по ссылке
                                this.openPrivacyPolicy();
                            }}
                          >
            условиями обработки персональных данных
          </a>
                </label>
              </div>
              <button type="submit" className="submit-button">Отправить</button>
            </form>



            <PrivacyPolicyModal
                isOpen={this.state.isPrivacyPolicyOpen}
                onClose={this.closePrivacyPolicy}
                text={this.state.privacyPolicyText}
              />
          </div>
        </div>
    );
  }
}

export default Modal;